import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Countdown from '../countdown/countdown';
import LobbyCountHandler from './lobbyCountHandler';
import InterstitialAd from '../interstitial-ad/interstitialAd';
import Strings from '../../strings.json';

import './eliminationLobby.css';
import './background.jpg';
import logo from './logo.svg';


class MultiplayerLobby extends Component {

  constructor(props) {
    super(props);

    this.startGame = this.startGame.bind(this);
    this.renderBodyContent = this.renderBodyContent.bind(this);
    this.renderAd = this.renderAd.bind(this);
    this.onAdShown = this.onAdShown.bind(this);
    this.lobbyCountHandler = new LobbyCountHandler();
    this.countdownSeconds = 5;

    this.state = {
      showAd: this.props.showAd
    };
  }

  startGame() {
    this.props.startGame();
  }  

  renderLobbyStage() {
    if (this.props.lobbyReady && this.state.showAd === false) {
      return this.renderLobbyWaiting();
    } else {
      return this.renderLobbyFilling();
    }
  }
  
  renderLobbyFilling() {
    return (
      <div className='elimination-lobby-content'>
        <div className='elimination-lobby-content__title'>Finding other players&hellip;</div>
        <svg className='elimination-lobby-content__icon' width='35' height='20' viewBox='0 0 35 20' fill='#ffffff'>
          <path d='M26.6542308 17.5592L34.6919231 17.5592C34.6919231 13.5592 31.6916154 9.9184 27.9611538 9.9184 26.3836154 9.9184 24.9233077 10.5184 23.7696154 11.55904 25.3080769 13.07936 26.3462308 15.15904 26.6542308 17.55904L26.6542308 17.5592zM31.5384615 5.8408C31.5384615 7.89392 29.9368846 9.55956 27.9612308 9.55956 25.9855769 9.55956 24.384 7.89392 24.384 5.8408 24.384 3.78612 25.9855769 2.12048 27.9612308 2.12048 29.9368846 2.12048 31.5384615 3.78612 31.5384615 5.8408M11.0007692 11.6C9.84692308 10.52032 8.38507692 9.84064 6.77 9.84064 3.07707692 9.84064.0392307692 13.52032.0392307692 17.52024L8.07692308 17.52024C8.38491538 15.15932 9.46215385 13.12024 11.0006154 11.59984L11.0007692 11.6zM10.3453846 5.8408C10.3453846 7.89392 8.74380769 9.55956 6.76965385 9.55956 4.794 9.55956 3.19242308 7.89392 3.19242308 5.8408 3.19242308 3.78612 4.794 2.12048 6.76965385 2.12048 8.74380769 2.12048 10.3453846 3.78612 10.3453846 5.8408M21.8838462 4.6796C21.8838462 7.26396 19.8691154 9.3592 17.3842308 9.3592 14.8992692 9.3592 12.8846154 7.26388 12.8846154 4.6796 12.8846154 2.09524 14.8993462 0 17.3842308 0 19.8691923 0 21.8838462 2.09532 21.8838462 4.6796M8.88538462 19.6408C8.88538462 14.2816 12.6924615 9.9204 17.3469231 9.9204 22.0015385 9.9204 25.8084615 14.2796 25.8084615 19.6408L8.88538462 19.6408z' />
        </svg>
        <div className='elimination-lobby-content__copy'>
          <strong>{this.props.playerCount}</strong> players in the lobby
        </div>
      </div>
    );
  }

  renderLobbyWaiting() {
    return (
      <div className='elimination-lobby-content'>
        <div className='elimination-lobby-content-skull'>
          <svg width='70' height='93' viewBox='0 0 70 83' fill='#ffffff'>
            <path d='M67.0732069,50.2080283 C65.1584038,44.9477864 68.390044,43.2999405 69.0875951,31.5939116 C71.4863835,-8.69476337 -1.96129865,-10.1999284 1.10643535,31.5939116 C1.96416984,43.2890071 5.03207331,44.9472398 3.12082354,50.2080283 C1.20602042,55.4682702 -0.626873298,58.0877311 2.71153164,61.7181672 C6.0499548,65.348421 9.76558033,68.989335 13.032663,67.0175871 C20.1258898,62.7360669 20.3500245,67.8824374 20.3572223,72.484288 C20.3572223,72.484288 19.5457635,76.2461983 19.1293102,77.4812171 C18.0010742,80.8338555 24.987518,81.5349599 25.4715033,80.1682847 C25.9555341,78.7980561 26.0480671,73.7833584 27.2510056,74.5734789 C28.1478907,75.160721 27.4076083,78.5702769 27.6602975,80.5384706 C27.941459,82.741551 32.2834865,83.7914319 33.1768365,81.6062093 C34.0843909,79.3818078 33.8708524,74.1785098 35.1236198,74.534392 C36.3728521,74.1784915 36.1592863,79.3818078 37.0704031,81.6062093 C37.9637259,83.7914319 42.3022182,82.741551 42.5869422,80.5384706 C42.8396313,78.570276 42.0993489,75.1607848 42.9962341,74.5734789 C44.202735,73.7833675 44.2917511,78.7980561 44.7757364,80.1682847 C45.2597672,81.5385133 52.2461654,80.8373907 51.1179295,77.4812171 C50.7050751,76.2461983 49.8900173,72.484288 49.8900173,72.484288 C49.904249,64.7041703 49.2992127,62.2697573 57.1682919,67.0175871 C60.4354657,68.989335 64.1511823,65.348421 67.4894233,61.7181672 C70.8206486,58.0843599 68.9877549,55.4684524 67.0730155,50.2080283 L67.0732069,50.2080283 Z M10.4099404,54.5785646 C7.29574306,52.5748365 7.08226839,49.143935 9.22831296,44.6492134 C13.3710701,35.9758368 27.8387852,34.1923256 31.237251,39.0294449 C32.3014355,41.3641817 17.9622789,59.4339062 10.4100315,54.5785646 L10.4099404,54.5785646 Z M39.8435694,64.1598691 C38.7188868,64.5762769 37.0497208,60.9175688 33.8394918,60.8535173 C30.6292627,60.7894567 29.6718612,64.1242445 28.2090631,64.060193 C25.675065,63.9498658 30.7715792,51.418447 34.3484416,51.0376002 C36.6368938,50.7635545 41.9648316,63.3732109 39.8435694,64.1595047 L39.8435694,64.1598691 Z M59.7815389,54.5785646 C52.2292004,59.4330862 37.890135,41.3637262 38.9543194,39.0294449 C42.3532407,34.1926901 56.8204092,35.9721923 60.9632574,44.6492134 C63.1093931,49.1442994 62.8958273,52.5752009 59.78163,54.5785646 L59.7815389,54.5785646 Z' />
          </svg>
          <div className='elimination-lobby-content-skull__timer'>
            <Countdown startTimeSeconds={this.countdownSeconds} timerComplete={this.startGame} enabled />
          </div>
        </div>
        <div className='elimination-lobby-content__title'>Get ready!</div>
        <svg className='elimination-lobby-content__icon' width='35' height='20' viewBox='0 0 35 20' fill='#ffffff'>
          <path d='M26.6542308 17.5592L34.6919231 17.5592C34.6919231 13.5592 31.6916154 9.9184 27.9611538 9.9184 26.3836154 9.9184 24.9233077 10.5184 23.7696154 11.55904 25.3080769 13.07936 26.3462308 15.15904 26.6542308 17.55904L26.6542308 17.5592zM31.5384615 5.8408C31.5384615 7.89392 29.9368846 9.55956 27.9612308 9.55956 25.9855769 9.55956 24.384 7.89392 24.384 5.8408 24.384 3.78612 25.9855769 2.12048 27.9612308 2.12048 29.9368846 2.12048 31.5384615 3.78612 31.5384615 5.8408M11.0007692 11.6C9.84692308 10.52032 8.38507692 9.84064 6.77 9.84064 3.07707692 9.84064.0392307692 13.52032.0392307692 17.52024L8.07692308 17.52024C8.38491538 15.15932 9.46215385 13.12024 11.0006154 11.59984L11.0007692 11.6zM10.3453846 5.8408C10.3453846 7.89392 8.74380769 9.55956 6.76965385 9.55956 4.794 9.55956 3.19242308 7.89392 3.19242308 5.8408 3.19242308 3.78612 4.794 2.12048 6.76965385 2.12048 8.74380769 2.12048 10.3453846 3.78612 10.3453846 5.8408M21.8838462 4.6796C21.8838462 7.26396 19.8691154 9.3592 17.3842308 9.3592 14.8992692 9.3592 12.8846154 7.26388 12.8846154 4.6796 12.8846154 2.09524 14.8993462 0 17.3842308 0 19.8691923 0 21.8838462 2.09532 21.8838462 4.6796M8.88538462 19.6408C8.88538462 14.2816 12.6924615 9.9204 17.3469231 9.9204 22.0015385 9.9204 25.8084615 14.2796 25.8084615 19.6408L8.88538462 19.6408z' />
        </svg>
        <div className='elimination-lobby-content__copy'>
          <strong>{this.props.playerCount}</strong> players in the lobby
        </div>
      </div>
    );
  }

  onAdShown() {
    this.setState({ showAd: false });
  }

  renderBodyContent() {
    if (!this.state.showAd) {
      return (
        <div className='elimination-lobby__text'>
          <h2 className='game-chooser__title'><strong>{Strings.gameStart.title}</strong></h2>
          <div className='game-chooser__title--sub' dangerouslySetInnerHTML={{__html: Strings.gameStart.description}} />
        </div>
      )
    }
  }

  renderAd() {
    if (this.state.showAd) {
      return <InterstitialAd adFinished={this.onAdShown} small />
    }
  }

  render() {
    return (
      <div className='elimination-lobby'>
        <div className='elimination-lobby-logo'>
          <img className='elimination-lobby-logo__image' alt='Elimination Mode' src={logo} />
          {this.renderBodyContent()}
        </div>
        {this.renderAd()}
        <div className='elimination-lobby-content-wrapper'>
          {this.renderLobbyStage()}
        </div>
      </div>
    );
  }
}

export default MultiplayerLobby;

MultiplayerLobby.propTypes = {
  startGame: PropTypes.func, 
  showAd: PropTypes.bool,
  playerCount: PropTypes.number, 
  roomName: PropTypes.string,
  lobbyReady: PropTypes.bool
}


// WEBPACK FOOTER //
// ./src/components/elimination-lobby/eliminationLobby.js